import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomBadge from "../../../../components/CustomBadge";
import { getLeagueAction } from "../../../../redux/actions/leagueAction";
import "../Wrapper/wrapper.css";
import "./leaderlist.css";
import { TextField, InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

const LeaderList = () => {
  const dispatch = useDispatch();
  const { league } = useSelector(({ league }) => league);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    getLeagueAction(dispatch);
  }, [dispatch]);

  if (!league) {
    return (
      <div className="container mt-4">
        <p className="text-center">Complete your profile to view League List</p>
      </div>
    );
  }

  const filteredLeague = league.filter((person) => {
    const fullName = `${person.first_name} ${person.last_name}`.toLowerCase();
    const username = person.username.toLowerCase();
    const search = searchTerm.toLowerCase();
    return fullName.includes(search) || username.includes(search);
  });

  return (
    <div className="league-container">
      <div className="search-container mb-4">
        <TextField
          size="small"
          variant="outlined"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className="search-icon" />
              </InputAdornment>
            ),
            className: "search-input",
          }}
        />
      </div>

      <div className="league-table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>User Info</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            {filteredLeague.map((person, index) => (
              <tr key={person.id} className={index % 2 === 0 ? "even" : "odd"}>
                <td>
                  <div className="rank-number">{index + 1}</div>
                </td>
                <td>
                  <div className="user-info">
                    <img
                      className="avatar-img"
                      src={person.image_url}
                      alt={`${person.first_name}'s avatar`}
                    />
                    <div className="user-details">
                      <h6 className="user-name">
                        {person.first_name} {person.last_name}
                      </h6>
                      <span className="user-handle">@{person.username}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="position-badge">
                    <CustomBadge figure={index + 1} />
                  </div>
                </td>
              </tr>
            ))}
            {filteredLeague.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center py-4">
                  No results found for &ldquo;{searchTerm}&rdquo;
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeaderList;
